import { useEffect, useRef, useState } from 'react'

import styles from './BillingRowHolder.module.scss'

const BillingRowHolder = ({
  title = 'Title',
  children,
  isSearchable,
  searchValue,
  setSearchValue
}) => {
  const footerRef = useRef()

  const inputRef = useRef()

  const [paginationSize, setPaginationSize] = useState(6)
  const [isSearchVisible, setSearchVisible] = useState()

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [isSearchVisible])

  function handleSeeMoreClick() {
    setPaginationSize(a => a + 8)
    setTimeout(() => {
      footerRef.current.scrollIntoView({ behavior: 'smooth' })
    }, 0)
  }

  return (
    <div className={styles.rowHolder}>
      <div className={styles.titleRow}>
        <span className={styles.title}>{title}</span>
        {isSearchable && (
          <div className={styles.searchContainer}>
            <input
              type="search"
              ref={inputRef}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              placeholder="Search invoices"
              onBlur={() => setSearchVisible(false)}
            />
          </div>
        )}
      </div>
      {children && children.slice(0, paginationSize)}
      {Array.isArray(children) && children.length === 0 && (
        <div className={styles.noResults}>No results</div>
      )}
      <div className={styles.controls}>
        {children && children.length >= paginationSize && (
          <button className={styles.seeMoreButton} onClick={handleSeeMoreClick}>
            See more
          </button>
        )}
      </div>
      <div ref={footerRef}></div>
    </div>
  )
}

export default BillingRowHolder
